import axios from "axios";
import Endpoints from "../Endpoints";

const authHeader = () => ({
    headers: { 'Authorization': `Bearer ${localStorage.getItem('USER_TOKEN')}` }
});

export const getCountries = async () => {
    const { data } = await axios.get(Endpoints.Country.LIST);
    return data.data;
};

export const createCountry = async (name) => {
    const { data } = await axios.post(Endpoints.Country.CREATE, { name }, authHeader());
    return data.data;
};

export const updateCountry = async (id, name) => {
    const { data } = await axios.put(Endpoints.Country.UPDATE + id, { name }, authHeader());
    return data.data;
};

export const deleteCountry = async (id) => {
    const { data } = await axios.delete(Endpoints.Country.DELETE + id, authHeader());
    return data;
};
